import { useState, useEffect } from "react";
import classNames from "classnames";
import {
  volumeAllowedValues,
  VolumeAllowedValues,
} from "shared/games/mixpuzzles/types";
import VolumeSlider from "ui/atoms/VolumeSlider";

interface Props {
  value: VolumeAllowedValues;
  onChange: (value: VolumeAllowedValues) => void;
  theme?: "default" | "white";
}

export default function MixPuzzleVolumeSlider({
  onChange,
  value,
  theme,
}: Props) {
  return (
    <VolumeSlider
      steps={8}
      theme={theme}
      value={value}
      onChange={(x) => {
        onChange(assertVolume(x));
      }}
    />
  );
}

const volumeAllowedValuesSet = new Set(volumeAllowedValues);

function assertVolume(number: number): VolumeAllowedValues {
  if (volumeAllowedValuesSet.has(number as VolumeAllowedValues)) {
    return number as VolumeAllowedValues;
  }

  throw new Error(`Invalid volume value: ${number}`);
}
